import { Deserializable } from '../protocols/deserializable';
import { LifeStatusTypeIdEnum } from '../life-status/enum/life-status-type-id.enum';

export class MemberPaymentSuspension implements Deserializable {
  public memberId!: number;
  public suspendPayments: boolean = false;
  public suspendPaymentsChangedById: number | null = null;
  public suspendPaymentsChangedByName: string | null = null;
  public suspendPaymentsChangedDate: string | null = null;
  public lifeStatusHoldsPayments: boolean = false;
  public lifeStatusId!: LifeStatusTypeIdEnum;
  public lifeStatusEffectiveDate: string | null = null;

  public onDeserialize(): void {}
}
